import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-[#121E19] py-4 md:py-6 px-3 border-b border-[#1F3D2B]" data-id="element-57">
      <div className="max-w-2xl mx-auto" data-id="element-58">
        <div className="bg-[#0B1F17] border border-[#D4A843] rounded-xl p-3 md:p-4 flex items-center gap-3 shadow-xl" data-id="element-59">
          <div className="flex-shrink-0 bg-[#102A1F] rounded-full p-2.5 border border-[#D4A843]/30" data-id="element-60">
            <ShieldCheckIcon className="w-8 h-8 md:w-10 md:h-10 text-[#D4A843]" strokeWidth={2} data-id="element-61" />
          </div>
          <div data-id="element-62">
            <h3 className="font-black text-white text-sm md:text-base uppercase mb-1" data-id="element-63">
              🔒 Garantía de 7 días
            </h3>
            <p className="text-[#BFC9C5] text-xs md:text-sm font-bold leading-snug" data-id="element-64">
              Si el material no cumple tus expectativas, te devolvemos el 100%
              de tu dinero. Sin preguntas, sin vueltas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}